export class MissingI18nInterpolationError extends Error {}
